import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";
import { useTranslation } from "react-i18next";

//styles
import './style.scss';

//antd component
import { Button } from 'antd';

//assets
import CustomIcons from 'components/CustomIcons';

function FinalControlScreen({
  continueAction,
  loading,
  title,
  content,
  children,
  className,
}) {
  const childClassName = classNames('control-final-screen', className);
  const { t } = useTranslation();

  return (
    <div className={childClassName}>
      <div className="control-final-screen__icon">
        <CustomIcons type="present-finish" />
      </div>
      <div className="control-final-screen__content">
        <h3 className="content-title">
          {!!title && title || t("screens.controlScreenTitle")}
        </h3>

        {(content || children) && (
          <div
            className="content-text"
            dangerouslySetInnerHTML={{
              __html: !!(content || children) && (content || children) || t("screens.controlScreenContent")
            }}
          />
        )}
      </div>

      {continueAction !== undefined && (
        <Button loading={loading} onClick={continueAction} className="control-final-screen__btn">
          {t("common.continue")}
        </Button>
      )}
    </div>
  );
}

FinalControlScreen.defaultProps = {
  loading: false
};

FinalControlScreen.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
  continueAction: PropTypes.func,
};

export default memo(FinalControlScreen);
